import React, { useCallback, useMemo, useState } from 'react';
import InputConfirmationModal from '../InputConfirmationModal';
import useConfirmationProps from './useConfirmationProps';

const useInputConfirmation = ({
  title,
  requiredInput,
}: {
  title: string;
  requiredInput: string;
}) => {
  const [body, setBody] = useState<React.ReactNode>('');
  const { getConfirmation, onConfirmed, onCancelled, isOpen } =
    useConfirmationProps();

  const InputConfirmation = useMemo(
    () => (
      <InputConfirmationModal
        requiredInput={requiredInput}
        isOpen={isOpen}
        close={onCancelled}
        title={title}
        body={body}
        onConfirmed={onConfirmed}
      />
    ),
    [requiredInput, body, isOpen, onCancelled, onConfirmed, title],
  );

  const getConfirmationThat = useCallback(
    (confirmationBody: React.ReactNode) => {
      setBody(confirmationBody);
      return getConfirmation();
    },
    [getConfirmation],
  );

  return { getConfirmationThat, InputConfirmation };
};

export default useInputConfirmation;
